import { createContext, useContext, RefObject } from 'react'
// @ts-ignore
const MainContainerContext = createContext<RefObject<HTMLDivElement>>()

export const MainContainerProvider = MainContainerContext.Provider

export function useMainContainer(): RefObject<HTMLDivElement> {
  return useContext(MainContainerContext)
}
